import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";
import { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";
import axios from "axios";
export const getUniversities = createAsyncThunk(
  "scholarship/getUniversities",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}scholarship/university`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getDroppedOutRequests = createAsyncThunk<
  any,
  {
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
    partner_id?: number;
  }
>("scholarship/getDroppedOutRequests", async (data) => {
  try {
    const response = await CAxios.post(`dropout/requests`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getAllUniversitiesScholarship = createAsyncThunk<
  any,
  {
    partner_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("scholarship/getAllUniversitiesScholarship", async (data) => {
  try {
    const response = await CAxios.post(
      `scholarship/applications/college`,
      data
    );
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getAllSchoolScholarship = createAsyncThunk<
  any,
  {
    partner_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("scholarship/getAllSchoolScholarship", async (data) => {
  try {
    const response = await CAxios.post(`scholarship/applications/school`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const addScolarshipUniversity = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("scholarship/addScolarshipUniversity", async (data) => {
  try {
    const response = await CAxios.post(
      `scholarship/application/college`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const AddDroppedOutRequest = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("scholarship/AddDroppedOutRequest", async (request) => {
  try {
    const response = await CAxios.post(`dropout`, request);
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const addScolarshipSchool = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("scholarship/addScolarshipSchool", async (data) => {
  try {
    const response = await CAxios.post(`scholarship/application/school`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response?.data;
  } catch (error) {
    throw error;
  }
});
// get all university applications
export const getAlluniversityApplications = createAsyncThunk<
  any,
  {
    partner_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("university/applications", async (data) => {
  try {
    const response = await CAxios.post(`university/applications`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

// add university application
export const addUniversityApplication = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("university/application", async (data) => {
  try {
    const response = await CAxios.post(`university/application`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response?.data;
  } catch (error) {
    throw error;
  }
});

// to add commitment attachment
export const addCommitmentAttachment = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("scholarship/commitment/documents", async (data: any) => {
  try {
    const response = await CAxios.post(
      `scholarship/commitment/documents`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
});

export const getClub = createAsyncThunk("scholarship/getClub", async () => {
  try {
    const response = await CAxios.get(`club`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});
